import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../services/transaksi/TransaksiService'
import { formatDateStringLocalDate } from './Utils'

const GetDokumenTanggal = ({nomorAju, idJnsDok}) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [nomorDokumen, setNomorDokumen] = useState('')

    useEffect(() => {
        const getNomorDokumen = async () => {
            const response = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
            setNomorDokumen(response.data.tanggal)
        }
        getNomorDokumen()
    }, [transaksiService, nomorAju, idJnsDok])

    return (
        <>
            {formatDateStringLocalDate(nomorDokumen)}
        </>
    )

}

export default GetDokumenTanggal